<template>
  <div
    class="app-wrapper"
    :class="isCollapse ? 'hideSidebar' : ''"
    @mouseover="OperatingWebsite()"
  >
    <div class="sidebar-container">
      <div
        class="sidebar-logoFuSHENG"
        :class="isCollapse ? 'slide' : ''"
        v-if="FUSHENG"
      >
        <img :src="logo" alt="" />
      </div>
      <div
        class="sidebar-logo"
        :class="isCollapse ? 'slide' : ''"
        v-if="!FUSHENG"
      >
      <span style="    display: inline-block;
    font-size: 24px;
    color: #fff;
    text-align: center;
    width: 100%;
    line-height: 67px;
    font-weight: bold;
    font-family: none;"> 东乐 e 聘</span>
        <!-- <img style="    width: 180px;position: relative;left: 34px;" v-if="$xlpSource" src="https://leylh.oss-cn-beijing.aliyuncs.com/flogo.png" alt="">
        <img v-if="!$xlpSource" :src="logo" alt="" /> -->
      </div>
      <!-- <div> -->
      <div class="sidebar-box" :class="isCollapse ? 'slide' : ''">
        <!-- <el-menu  class="el-menu-vertical-demo" :unique-opened="true" :collapse="isCollapse" :defaultOpeneds="defaultOpeneds">
                        <menu-list v-if="type" :menus="menuList"></menu-list>
                    </el-menu> -->
        <menu-list :data="menuList" :isCollapse="isCollapse"></menu-list>
      </div>
      <!-- </div> -->
    </div>

    <div class="main-container">
      <div class="fixed-header">
        <div class="nav clear">
          <div class="nav-slide">
            <i
              class="collapse-menu el-icon-s-fold"
              style="float: left"
              @click="collapseMenu"
            ></i>
            <!-- <span style="float:left;margin-left: 10px;line-height: 88px;    font-size: 13px;">东乐 e 聘一站式智能招聘用工服务平台~</span> -->
          </div>
          <!-- 测试环境提示信息 -->
          <!-- <div class="tishi" style="font-size:30px;color:#fff;">Test system</div> -->
          <tags-view
            style="float: left;width: calc(100% - 475px);"
          ></tags-view>
          <div class="nav-menu">
            <span>
              <!-- <img src="https://leylh.oss-cn-beijing.aliyuncs.com/front/huanfu.png" alt=""> -->
            </span>

            <!-- <span>{{userNick}}</span> -->
            <el-badge
              :value="messagenumber"
              @click.native="gomessage()"
              :max="99"
              style="cursor: pointer"
              class="item"
              v-if="roleType == 0"
            >
              <span
                class="el-dropdown-link"
                style="font-size: 25px; color: #fff"
              >
               <img  class="user-fullscreen" style="margin-top:-10px;" src="https://leylh.oss-cn-beijing.aliyuncs.com/icon_notification%403x%20%281%29.png" alt="">
              </span>
            </el-badge>
            <el-dropdown class="el-dropdown" v-if="roleType != 0">
              <el-badge :value="newsNumber" :max="99" class="item" >
                <span
                  class="el-dropdown-link"
                  style="font-size: 25px; color: #fff;"
                >
                  <img  class="user-fullscreen"  style="margin-top:-10px;"  src="https://leylh.oss-cn-beijing.aliyuncs.com/icon_notification%403x%20%281%29.png" alt="">
                </span>
              </el-badge>
              <el-dropdown-menu slot="dropdown" class="margin_icon">
                <el-tabs
                  v-model="activeName"
                  type="card"
                  style="width: 328px; padding: 0"
                >
                  <el-tab-pane label="未读消息" name="first" class="panel">
                    <template v-if="unRead.length != 0">
                      <router-link
                        class="head-news"
                        v-for="(read, index) in unRead"
                        :key="index"
                        :to="
                          read.messageFunctionCode
                            ? read.messageFunctionCode
                            : '/'
                        "
                        >· <span>{{ read.messageFuinctionDesc }}</span>
                        {{ read.messageCreateTime | formatDate }}</router-link
                      >
                      <router-link class="head-news-more" to="/news/newsManage"
                        >更多></router-link
                      >
                    </template>
                    <template v-else> 暂无消息 </template>
                  </el-tab-pane>
                  <el-tab-pane label="已读消息" name="second" class="panel">
                    <template v-if="Read.length != 0">
                      <router-link
                        class="head-news"
                        v-for="(read, index) in Read"
                        :key="index"
                        :to="
                          read.messageFunctionCode
                            ? read.messageFunctionCode
                            : '/'
                        "
                        >· <span>{{ read.messageFuinctionDesc }}</span>
                        {{ read.messageCreateTime | formatDate }}</router-link
                      >
                      <router-link class="head-news-more" to="/news/newsManage"
                        >更多></router-link
                      >
                    </template>
                    <template v-else> 暂无消息 </template>
                  </el-tab-pane>
                </el-tabs>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              class="avatar-container right-menu-item hover-effect margin_icon"
              placement="bottom-start"
            >
              <div
                class="avatar-wrapper"
                style="font-size: 27px; cursor: pointer"
              >
                <img
                  style="width: 21px; position: relative; top: 3px"
                  src="https://leylh.oss-cn-beijing.aliyuncs.com/icon_pifu_24%403x.png"
                  alt=""
                />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  class="item-down-color"
                  v-for="(item, index) in zColor"
                  @click.native="tagClick(item)"
                  :key="item.index"
                >
                  <span :class="'hfshezhi  hfColor' + index"></span>
                  <span style="float: left">{{ item.lable }}</span>
                  <div style="clear: both"></div>
                  <!-- <i class="el-icon-check icon_se" v-if="item.show"></i> -->
                </el-dropdown-item>
                <!-- <el-tag
                                class="tagsClass"
                                v-for="item in zColor"
                                :key="item.label"
                                :color="item.color"
                                @click="tagClick(item)"
                                :hit="false"
                                type="success"
                                effect="dark">
                                
                            </el-tag> -->
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              class="avatar-container right-menu-item hover-effect margin_icon"
            >
              <el-tooltip
                effect="dark"
                :content="isFullScreen ? '退出全屏' : '全屏'"
                placement="bottom"
              >
                <div
                  class="avatar-wrapper"
                  style="font-size: 27px; cursor: pointer"
                >
                  <img
                    src="https://leylh.oss-cn-beijing.aliyuncs.com/icon_quanping_24%403x.png"
                    class="user-fullscreen"
                    @click="toggleFullScreen"
                    v-if="!isFullScreen"
                  />
                  <img
                    src="https://leylh.oss-cn-beijing.aliyuncs.com/front/editFullScreen.png"
                    class="user-fullscreen"
                    @click="toggleFullScreen"
                    v-if="isFullScreen"
                  />
                </div>
              </el-tooltip>
              <el-dropdown-menu> </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              class="avatar-container right-menu-item hover-effect margin_icon"
            >
              <div
                class="avatar-wrapper"
                style="font-size: 25px; cursor: pointer; display: flex"
              >
                <div
                  v-if="authStaus != 0"
                  class="avatar-wrapper"
                  style="font-size: 25px; cursor: pointer; display: flex"
                >
                  <div class="person-name">{{ userNick }}</div>
                  <div class="person-img">
                    <img :src="userImage" alt="" />
                  </div>
                </div>
                <div
                  v-if="authStaus == 0"
                  class="avatar-wrapper"
                  style="font-size: 25px; cursor: pointer; display: flex"
                >
                  <div class="person-name">未认证</div>
                  <div class="person-img">
                    <img src="../assets/images/zhaopin/touxiang.png" />
                  </div>
                </div>
                <!-- <i class="el-icon-setting el-icon--right imgBox" style="position: relative;top: 2px;"/> -->
              </div>
              <div class="person">
                <el-dropdown-menu slot="dropdown" style="width: 197px">
                  <el-dropdown-item>
                    <div
                      style="display: flex; height: 62px; line-height: 62px"
                      v-if="authStaus == 0"
                    >
                      <div class="person-img0">
                        <img
                          src="../assets/images/zhaopin/touxiang.png"
                          alt=""
                        />
                      </div>
                      <!-- 111 -->
                      <div class="person-phone">未认证</div>
                    </div>
                    <div class="person-right" v-if="authStaus == 1">
                      <div class="person-img1">
                        <img :src="userImage" alt="" />
                      </div>
                      <div class="person-r1">
                        <div class="pr">{{ userNick }}</div>
                        <div class="pr1">{{ orgName }}</div>
                      </div>
                    </div>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item>
                                        <span style="display:block;" @click="changePWD">修改密码</span>
                                </el-dropdown-item> -->
                  <el-dropdown-item>
                    <div style="display: flex">
                      <div class="person-img2">
                        <img src="../assets/gerenzx.png" alt="" />
                      </div>
                      <span style="display: block"
                        ><router-link to="/recruitSys/personIndex"
                          >个人中心</router-link
                        >
                      </span>
                    </div>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item>
                                    <span style="display:block;" @click="changeCss">系统设置</span>
                                </el-dropdown-item> -->
                  <el-dropdown-item v-if="!this.$xlpSource">
                    <div style="display: flex">
                      <div class="person-img2">
                        <img src="../assets/qiehuanzz.png" alt="" />
                      </div>
                      <span style="display: block" @click="changeDuty"
                        >切换职责</span
                      >
                    </div>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item v-if="!FUSHENG">
                                    <span style="display:block;" @click="gotoFileCenter">在线文档</span>
                                </el-dropdown-item> -->
                  <el-dropdown-item>
                    <div style="display: flex" @click="logout">
                      <div class="person-img2">
                        <img src="../assets/tuichudl.png" alt="" />
                      </div>
                      <span style="display: block">退出登录</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div style="display: flex">
                      <div class="person-img2">
                        <img
                          src="https://leylh.oss-cn-beijing.aliyuncs.com/front/enterpriseImg/icon_share_16%403x.png"
                          alt=""
                        />
                      </div>

                      <span style="display: block" @click="sharebtn">分享</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </div>
            </el-dropdown>
            <!-- <img :src="avatar" class="user-avatar"> -->
          </div>
        </div>
      </div>
      
      <div :class="[isindex ? 'main-box main-box1' : 'main-box']">
        <div class="small-box">
          <!-- <keep-alive :include="cachedViews">
            <router-view></router-view>
          </keep-alive> -->

          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        title="邀请二维码"
        :visible.sync="sharedialog"
        width="320px"
        :before-close="sharehandleClose"
      >
        <div class="erweimapic">
          <img :src="this.wechatimg1" alt="" />
        </div>
        <div class="savepic" @click="downImg">保存图片</div>
        <div style="height: 2px; border-top: 1px solid #f8f8f8"></div>
        <div class="yaoqinglj">邀请链接</div>
        <div style="display: flex">
          <div class="yaoqing">
            {{ wechaturl }}
          </div>
          <div class="copylj" @click="copyclick">复制链接</div>
        </div>
      </el-dialog>
    </div>
    <!-- 修改密码弹窗 -->
    <div v-if="passInit == null">
      <el-dialog
        title="修改密码"
        :visible.sync="dialogPasswordVisible"
        width="30%"
        :close-on-click-modal="false"
        :before-close="handleCloseOne"
        :fullscreen="dialogFull"
      >
        <template slot="title">
          <div class="avue-crud__dialog__header">
            <span class="el-dialog__title">
              <span
                style="
                  display: inline-block;
                  width: 3px;
                  height: 20px;
                  margin-right: 5px;
                  float: left;
                  margin-top: 2px;
                "
              ></span>
              修改密码
            </span>
            <div class="avue-crud__dialog__menu">
              <i
                class="el-icon-full-screen"
                @click="dialogFull ? (dialogFull = false) : (dialogFull = true)"
              ></i>
            </div>
          </div>
        </template>
        <el-form
          :model="pwdData"
          :rules="rules"
          ref="pwdData"
          :label-position="labelPosition"
          label-width="90px"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="原密码" prop="oldPwd">
                <el-input
                  v-model="pwdData.oldPwd"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="新密码" prop="newPwd">
                <el-input
                  v-model="pwdData.newPwd"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="确认密码" prop="conPwd">
                <el-input
                  v-model="pwdData.conPwd"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseOne()" icon="el-icon-close"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changeThePassword('pwdData')"
            icon="el-icon-check"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div v-else>
      <el-dialog
        title="修改密码"
        :visible.sync="dialogPasswordVisible"
        width="30%"
        :close-on-click-modal="false"
        :before-close="handleCloseOne"
        :fullscreen="dialogFull"
      >
        <template slot="title">
          <div class="avue-crud__dialog__header">
            <span class="el-dialog__title">
              <span
                style="
                  display: inline-block;
                  width: 3px;
                  height: 20px;
                  margin-right: 5px;
                  float: left;
                  margin-top: 2px;
                "
              ></span>
              修改密码
            </span>
            <div class="avue-crud__dialog__menu">
              <i
                class="el-icon-full-screen"
                @click="dialogFull ? (dialogFull = false) : (dialogFull = true)"
              ></i>
            </div>
          </div>
        </template>
        <el-form
          :model="pwdData"
          :rules="rules"
          ref="pwdData"
          :label-position="labelPosition"
          label-width="90px"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="新密码" prop="newPwd">
                <el-input
                  v-model="pwdData.newPwd"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="确认密码" prop="conPwd">
                <el-input
                  v-model="pwdData.conPwd"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseOne()" icon="el-icon-close"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changeThePassword('pwdData')"
            icon="el-icon-check"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 切换职责弹窗 -->
    <el-dialog
      title="切换职责"
      :visible.sync="dialogDutyVisible"
      width="1000px"
      :before-close="handleCloseTwo"
      :fullscreen="dialogFullTwo"
    >
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            <span
              style="
                display: inline-block;
                width: 3px;
                height: 20px;
                margin-right: 5px;
                float: left;
                margin-top: 2px;
              "
            ></span>
            切换职责
          </span>
          <div class="avue-crud__dialog__menu">
            <i
              class="el-icon-full-screen"
              @click="
                dialogFullTwo ? (dialogFullTwo = false) : (dialogFullTwo = true)
              "
            ></i>
          </div>
        </div>
      </template>
      <el-form
        :model="userDuty"
        :rules="dutys"
        ref="userDuty"
        :label-position="labelPosition"
        label-width="90px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="职责切换" prop="duty">
              <el-radio-group v-model="userDuty.duty">
                <div
                  class="duty-item"
                  v-for="(duty, index) in dutyLists"
                  :key="duty.jurUserDutyId"
                >
                  <el-radio
                    :label="duty.jurUserDutyId"
                    @change="handleDutyChange($event, index)"
                  >
                    {{ duty.dutyName }}
                  </el-radio>
                </div>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseTwo()" icon="el-icon-close"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="changeUserDuty('userDuty')"
          icon="el-icon-check"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-card class="box-card" v-if="messageDialog">
      <div slot="header" class="clearfix">
        <span style="font-size: 20px; font-weight: 700; float: left">通知</span>
        <el-button
          style="
            float: left;
            padding: 3px 0;
            color: #169bd5;
            margin-top: 5px;
            margin-left: 10px;
          "
          type="text"
          @click="deletemsg()"
          >全部清除</el-button
        >
        <img
          style="float: right; width: 25px; height: 25px"
          @click="closemsg()"
          src="https://leylh.oss-cn-beijing.aliyuncs.com/front/enterpriseImg/83d0d2ea-72b5-4f5d-8ef7-3a8f473cf135.png"
          alt=""
        />
      </div>
      <div
        class="msglist"
        v-for="(item, index) in msgList"
        :key="index"
        v-if="item"
      >
        <div style="display: flex">
          <div class="msgimg">
            <i
              v-if="item.type == 9 || item.type == 4"
              style="font-size: 20px; color: #76d04a"
              class="el-icon-circle-check"
            ></i>
            <i
              v-if="item.type == 10 || item.type == 5"
              style="font-size: 20px; color: red"
              class="el-icon-warning-outline"
            ></i>
            <i
              v-if="item.type == 1 || item.type == 2 || item.type == 3"
              style="font-size: 20px; color: orange"
              class="el-icon-user"
            ></i>
          </div>
          <div>
            <div class="msgtitle">{{ item.title }}</div>
            <div class="msgcontent">{{ item.content }}</div>
            <!-- 职位管理 -->
            <router-link
              :to="{ name: 'positionManagement', query: { bohui: 3 } }"
              v-if="item.type == 10"
              @click.native="deletemsg(item,index)"

            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 报名管理 -->
            <router-link
              :to="{ name: 'signupadmin' }"
              @click.native="deletemsg(item,index)"
              v-if="item.type == 1"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 推荐管理 -->
            <router-link
              :to="{ name: 'recommendadmin' }"
              @click.native="deletemsg(item,index)"
              v-if="item.type == 2"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 精选管理 -->
            <router-link
              :to="{ name: 'selectionadmin' }"
              @click.native="deletemsg(item,index)"
              v-if="item.type == 3"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 企业驳回5 -->
            <router-link
              :to="{ name: 'information', query: { bohui: true } }"
              @click.native="deletemsg(item,index)"
              v-if="item.type == 5"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <div v-if="item.type == 6" class="msgsee">
              <div class="msgRefresh" @click="msgrefresh1(item,index)">我知道了</div>
              <div class="msgRefresh1" @click="msgrefresh(item,index)">立即刷新</div>
            </div>
          </div>
        </div>
        <div class="msgdelete" @click="deletemsg(item, index)">
          <i style="font-size: 15px; color: #a6a6a6" class="el-icon-close"></i>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" v-if="rongyundialog">
      <div slot="header" class="clearfix">
        <span style="font-size: 20px; font-weight: 700">通知</span>
        <el-button
          style="float: right; padding: 3px 0; color: #169bd5"
          type="text"
          @click="deletemsg1()"
          >X</el-button
        >
      </div>
      <div class="msglist">
        <div style="display: flex">
          <div class="msgimg">
            <i
              v-if="this.msgstatus == 9 || this.msgstatus == 4"
              style="font-size: 20px; color: #76d04a"
              class="el-icon-circle-check"
            ></i>
            <i
              v-if="this.msgstatus == 10 || this.msgstatus == 5"
              style="font-size: 20px; color: red"
              class="el-icon-warning-outline"
            ></i>
            <i
              v-if="
                this.msgstatus == 1 ||
                this.msgstatus == 2 ||
                this.msgstatus == 3
              "
              style="font-size: 20px; color: orange"
              class="el-icon-user"
            ></i>
          </div>
          <div>
            <div class="msgtitle">{{ msgtitle }}</div>
            <div class="msgcontent">{{ msgcont }}</div>
            <!-- 职位管理 -->
            <router-link
              :to="{ name: 'positionManagement', query: { bohui: 3 } }"
              v-if="this.msgstatus == 10"
              @click.native="msgevent"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 报名管理 -->
            <router-link
              :to="{ name: 'signupadmin' }"
              v-if="this.msgstatus == 1"
              @click.native="msgevent"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 推荐管理 -->
            <router-link
              :to="{ name: 'recommendadmin' }"
              v-if="this.msgstatus == 2"
              @click.native="msgevent"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 精选管理 -->
            <router-link
              :to="{ name: 'selectionadmin' }"
              v-if="this.msgstatus == 3"
              @click.native="msgevent"
            >
              <div class="msgsee">查看</div>
            </router-link>
            <!-- 企业驳回5 -->
            <router-link
              :to="{ name: 'information', query: { bohui: true } }"
              v-if="this.msgstatus == 5"
              @click.native="msgevent"
            >
              <div class="msgsee">查看</div>
            </router-link>
          </div>
        </div>
        <!-- <div class="msgdelete" @click="deletemsg(item)">
          <i style="font-size: 15px; color: red" class="el-icon-close"></i>
        </div> -->
      </div>
    </el-card>
  </div>
</template>
<script>
import $moment from "moment";
import logo from "@/assets/images/logo.png";
import FUSHENGlogo from "@/assets/images/FUSHENGlogo.png";
import avatar from "@/assets/images/avatar.gif";
import * as apis from "@/api/public";
import * as news from "@/api/news";
import getAuthority from "@/utils/authority.js";
import { toggleClass } from "@/utils/index.js";
import { Loading } from "element-ui";
import init from "@/utils/rongyun.js";
import * as RongIMLibM from "@rongcloud/imlib-next";
import axios from "axios";
import wechatimg1 from "@/assets/dbcode.jpg"
import qs from "qs";
// import menu from './menu'
export default {
  inject: ["reload"],
  name: "Layout",
  components: {
    menuList: () => import("./components/menuList.vue"),
    TagsView: () => import("./components/TagsView.vue"),
    menuList: () => import("./components/menu/index.vue"),
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.pwdData.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      authStaus: "",
      orgName: "",
      classColor: "custome-722ed1",
      FUSHENG: JSON.parse(process.env.VUE_APP_FUSHENG),
      avatar,
      // userNick: '',
      logo: "https://leylh.oss-cn-beijing.aliyuncs.com/%E7%BC%96%E7%BB%84%2017%403x.png",
      isCollapse: false,
      activeName: "first",
      labelPosition: "right",
      dialogPasswordVisible: false,
      dialogDutyVisible: false,
      dialogDutyVisibleCss: false,
      isFullScreen: false,
      browserKernel: "",
      canFullScreen: false,
      pwdData: {
        oldPwd: "",
        newPwd: "",
        conPwd: "",
      },
      rules: {
        oldPwd: [{ required: true, message: "请填写原密码", trigger: "blur" }],
        newPwd: [
          { required: true, message: "请填写新密码", trigger: "blur" },
          { min: 6, max: 24, message: "密码长度在6位以上", trigger: "blur" },
        ],
        conPwd: [
          { required: true, message: "请填写确认密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
          { min: 6, max: 24, message: "密码长度在6位以上", trigger: "blur" },
        ],
      },
      unRead: [], //未读数组
      Read: [], //已读数组
      newsNumber: 0,
      iconarr: ["", "", ""],
      currentTime: new Date().getTime(), //记录移动时间
      dutyLists: [],
      userDuty: {
        duty: "",
      },
      dutys: {
        duty: [
          { required: true, message: "请选择一个职责！", trigger: "change" },
        ],
      },
      choosedDuty: {},
      zColor: [
        {
          color: "#f5222d",
          lable: "薄暮",
          show: false,
        },
        {
          color: "#fa541c",
          lable: "火山",
          show: false,
        },
        {
          color: "#faad14",
          lable: "日暮",
          show: false,
        },
        {
          color: "#00ceb9",
          lable: "明青",
          show: false,
        },
        {
          color: "#52c41a",
          lable: "极光绿",
          show: false,
        },
        {
          color: "#1890ff",
          lable: "拂晓蓝",
          show: false,
        },
        {
          color: "#2f54eb",
          lable: "极客蓝",
          show: false,
        },
        {
          color: "#722ed1",
          lable: "酱紫",
          show: false,
        },
        {
          color: "#1e202d",
          lable: "黑色",
          show: false,
        },
      ],
      roleType: localStorage.getItem("roleType"),
      newsNumber1: 0,
      dialogFull: false,
      dialogFullTwo: false,
      loading: null,
      type: true,
      isindex: false,
      sharedialog: false,
      wechatimg:"",
      wechatimg1,
      wechaturl: "",
      rongyunIm: "",
      wechaturlText: "",
      messageDialog: false,
      msgId: [],
      msgtitle: "",
      msgcont: "",
      msgstatus: "",
      rongyundialog: false,
    };
  },
  filters: {
    formatDate(val) {
      return $moment(val).format("YYYY-MM-DD");
    },
  },
  computed: {
    userNick: {
      get: function () {
        return localStorage.getItem("userNick");
      },
    },
    userImage: {
      get: function () {
        return localStorage.getItem("userImage");
      },
    },
    userPhone: {
      get: function () {
        return localStorage.getItem("userPhone");
      },
    },
    passInit: {
      get: function () {
        return localStorage.getItem("passInit");
      },
    },
    dutyList: {
      get: function () {
        return JSON.parse(localStorage.getItem("dutyList"));
      },
    },
    token: {
      get: function () {
        return JSON.parse(localStorage.getItem("token"));
      },
    },
    menuList: {
      get: function () {
        return localStorage.getItem("menuList")
          ? JSON.parse(localStorage.getItem("menuList"))
          : "";
      },
    },
    messagenumber() {
      return this.$store.state.login.messagenumber;
    },
    // 默认展开的菜单
    defaultOpeneds() {
      let ary = [];
      let menuList = this.menuList;
      if (menuList.length == 1) {
        ary.push(menuList[0].menuId);
      }
      return ary;
    },
    themecolor: {
      get() {
        return this.$store.state.themecolor;
      },
      set(val) {
        this.$store.commit("setThemeColor", val);
      },
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
  },
  created() {
     
    this.canFullScreen =
      document.fullscreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled;
    if (document.webkitFullscreenEnabled) {
      this.browserKernel = "webkit";
    } else if (document.mozFullScreenEnabled) {
      this.browserKernel = "gecko";
    } else if (document.msFullscreenEnabled) {
      this.browserKernel = "trident";
    } else if (document.fullscreenEnabled) {
      this.browserKernel = "others";
    }
    if (this.canFullScreen) {
      this.addFullScreenListener();
    }
    this.getRongYunInitMessageFun();
    // this.getMenu();
    
      
  },
  beforeRouteEnter: (to, from, next) => {
    
    console.log(1222222222222)
    next((vm) => {
      
      if (
        to.path == "/recruitSys/recruitIndex" ||
        to.path == "/personalAccount/ledou" ||
        to.path == "/recruitSys/signupadmin" ||
        to.path == "/recruitSys/recommendadmin" ||
        to.path.indexOf("recruit") > -1||
        to.path.indexOf("/personalAccount/ledou") > -1||
        to.path == "/recruitSys/positionManagement"
      ) {
        vm.isindex = true;
      }else{
         vm.isindex = false;
      }
      // if (
      //   to.path == "/recruitSys/recruitIndex" ||
      //   to.path == "/personalAccount/ledou" ||
      //   to.path == "/recruitSys/positionManagement"
      // ) {
      //   vm.isindex = true;
      // }
      // if (
      //   from.path == "/recruitSys/recruitIndex" ||
      //   from.path == "/personalAccount/ledou" ||
      //   from.path == "/recruitSys/positionManagement"
      // ) {
      //   vm.isindex = false;
      // }
      // if (to.path == "/recruitSys/signupadmin") {
      //   vm.isindex = true;
      // }
      // if (from.path == "/recruitSys/signupadmin") {
      //   vm.isindex = false;
      // }
      // if (to.path == "/recruitSys/recommendadmin") {
      //   vm.isindex = true;
      // }
      // if (from.path == "/recruitSys/recommendadmin") {
      //   vm.isindex = false;
      // }
      // if (to.path.indexOf("recruit") > -1) {
      //   vm.isindex = true;
      // }
      // if (to.path.indexOf("/personalAccount/ledou") > -1) {
      //   vm.isindex = true;
      // }
    });
  },
  destroyed() {
    document.onkeydown = null;
    switch (this.browserKernel) {
      case "webkit":
        document.onwebkitfullscreenchange = null;
        break;
      case "gecko":
        document.onmozfullscreenchange = null;
        break;
      case "trident":
        document.onmsfullscreenchange = null;
        break;
      case "others":
        document.onfullscreenchange = null;
        break;
      default:
        break;
    }
  },
  mounted() {
    this.orgTempuserBind();
    this.getUserMessage();
    this.showmsgdialog();
    // this.defaultPermission();
    if (localStorage.getItem("menuList")) {
      this.getReadNews();
      this.getUnreadNews();
    }

    toggleClass(document.body, "custom-" + this.themecolor);
    let curcolor = this.$store.state.themecolor;
    this.classColor = "custome-" + curcolor;

    // console.log(this.menuList);
  },
  watch: {
    themecolor: {
      handler() {
        toggleClass(document.body, "custom-" + this.themecolor);
      },
    },
    $route() {
      let to = {
        path:this.$route.path
      }
      let vm = this;
      if (
        to.path == "/recruitSys/recruitIndex" ||
        to.path == "/personalAccount/ledou" ||
        to.path == "/recruitSys/signupadmin" ||
        to.path == "/recruitSys/recommendadmin" ||
        to.path.indexOf("recruit") > -1||
        to.path.indexOf("/personalAccount/ledou") > -1||
        to.path == "/recruitSys/positionManagement"
      ) {
        vm.isindex = true;
      }else{
         vm.isindex = false;
      }
      // console.log(this.$route.path);
    },
  },
  methods: {
    msgevent() {
      this.rongyundialog = false;
    },
    gomessage() {
      this.$router.push({
        path: "/message/index",
      });
    },
    defaultPermission() {
      Notification.requestPermission().then((permission) => {
        switch (permission) {
          case "default":
            // this.systemvalue = false
            break;
          case "granted":
            // this.systemvalue = true
            // this.showNotification();
            break;
          case "denied":
            //  this.systemvalue = false
            break;
        }
      });
    },
    async getRongYunInitMessageFun() {
      try {
        let res = await apis.getRongYunInitMessage();

        if (res.code == 200) {
          localStorage.setItem("rytoken", res.data.token);
          localStorage.setItem("recruiterId", res.data.recruiterId);
          localStorage.setItem("ryimage", res.data.image);
          this.initRong();
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 初始化融云
    initRong() {
      let _this = this;
      const _token = localStorage.getItem("rytoken");
      let userInfo = {
        appKey: window.global_config.IM_BASE_URL.indexOf('xcxtest') >-1 ? "82hegw5u8v70x" : "e0x9wycfepjlq",
        token: _token,
      };

      // 消息监听器
      let callbacks = {
        CONNECTED: function (instance) {
         
        },
        Success: function (id) {},
        Received: function (message) {},
      };
      // 建立connect
      init(userInfo, callbacks);
      setTimeout(() => {
        const Events = RongIMLibM.Events;
        RongIMLibM.addEventListener(Events.MESSAGES, function (messages) {
          console.log(messages, "监听消息111111111");
          messages.messages.forEach((item) => {
            console.log( item.content)
            // 系统通知
            _this.$store.dispatch(
              "login/setMagessNum",
              _this.messagenumber + 1
            );
            _this.newsNumber1 = _this.newsNumber1 + 1;
            if (item.conversationType == 6) {
              _this.rongyundialog = true;
              _this.messageDialog = false;
              _this.msgtitle = item.content.title;
              _this.msgcont = item.content.content.split("content=")[1].split("&status=")[0];
              _this.msgstatus = item.content.content.split("content=")[1].split("&status=")[1];
              
            }
             _this.$store.dispatch(
              "login/setNewMessage",
              item
            );
          });
        });
        const startTime = 0;
        const count = 10;
        const order = 0;
        RongIMLibM.getConversationList({
          count: count,
          startTime: startTime,
          order: order,
        }).then((res) => {
          if (res.code === 0) {
            this.getUnreadMessage(res.data);
          } else {
          }
        });
      }, 2000);
    },
    async getUnreadMessage(datas) {
      try {
        let res = await apis.getUnreadMessage();
        if (res.code == 200) {
          this.newsNumber1 = res.data;
          this.$store.dispatch("login/setMagessNum", res.data);
          this.newListMessageFun(datas);
        }
      } catch (e) {
        console.log(e);
      }
    },
    newListMessageFun(data) {
      let _this = this;
      let ary = [];
      data.map((item) => {
        if (item.targetId != "null") {
          if (item.latestMessage.messageType == "RC:ImgMsg") {
            item.latestMessage.messageType = 6;
          }
          if (item.latestMessage.messageType == "RC:TxtMsg") {
            item.latestMessage.messageType = 0;
          }
          ary.push({
            targetId: item.targetId,
            unReadCount: item.unreadMessageCount,
            content: item.latestMessage.content.content,
            type: Number(item.latestMessage.messageType),
          });
        }
      });

      let parmas;
      parmas = {
        sessionMyself: localStorage.getItem("userId"),
        newsNumberList: ary,
      };
      let formData = new FormData();
      formData.append("sessionNew", JSON.stringify(parmas));
      axios({
        method: "post",
        url: window.global_config.IM_BASE_URL + "/sessionNews/getNewsList",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: formData,
      }).then(function (response) {
        let len = 0;
        response.data.data.forEach((item) => {
          len += item.newsNumber;
        });
        _this.newsNumber1 = len + _this.newsNumber1;
        _this.$store.dispatch("login/setMagessNum", len + _this.messagenumber);
      });
    },
    copyclick() {
      let txa = document.createElement("textarea");
      txa.value = this.wechaturlText;
      document.body.appendChild(txa);
      txa.select();
      document.execCommand("Copy");
      document.body.removeChild(txa);
      this.$message.success("复制成功");
    },
    downImg() {
      window.open(this.wechatimg);
    },
    //通知
    async getUserMessage() {
      try {
        let data = {
          states: 0,
          pageSize:20,
          pageNum:1,
        };
        let roleType = localStorage.getItem("roleType");
        let res = await apis.getUserMessage(data);
        if (res.code == 200) {
          console.log(res.data.list)
          this.msgList = res.data.list;
          let msgdialog = localStorage.getItem("msgdialog");
          if (
            res.data.list.length > 0 &&
            roleType == 0 &&
            msgdialog != "true"
          ) {
            this.messageDialog = true;
          }
          // this.msgList.forEach((item, idx) => {
          //   let id = item.messageId.toString().split(",")
          //   this.msgId.push(id)
          // });
          // console.log(this.msgId);
        }
      } catch (e) {
        console.log(e);
      }
    },
    showmsgdialog() {
      let msgdialog = localStorage.getItem("msgdialog");
      console.log(msgdialog);

      if (msgdialog == "true") {
        this.messageDialog = false;
      }
    },
    closemsg() {
      localStorage.setItem("msgdialog", true);
      this.messageDialog = false;
    },
    // 修改通知
   async deletemsg(item1, idx) {
      let _this = this;
      let id = [];
      if (item1) {
        id = item1.messageId.toString().split(",");
      } else {
        id = this.msgList.map((item) => item.messageId).toString();
        id = id.split(",");
      }
      console.log(id);
      try {
        let res = await apis.updateStatus(id);
        if (res.code == 200) {
          // this.reload();
          // this.getUserMessage();
          // this.messageDialog = false;
          if (item1) {
            _this.msgList.forEach((item, index) => {
              if (idx == index) {
                _this.msgList.splice(index, 1);
              }
            });
            this.$forceUpdate();
             _this.$store.dispatch(
              "login/setMagessNum",
              _this.messagenumber - 1
            );
            if( _this.msgList.length <=0 ){
            _this.messageDialog = false;

            }
          } else {
            _this.messageDialog = false;
              let res =  apis.getUnreadMessage();
              if (res.code == 200) {
                _this.messagenumber = res.data;
              }
          }
        } else {
          this.messageDialog = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    deletemsg1() {
      this.rongyundialog = false;
    },
    msgrefresh(item1,idx) {
      window.location.reload();
      window.location.reload();
      this.deletemsg(item1,idx)
    },
    msgrefresh1(item1,idx) {
      this.deletemsg(item1,idx)
    },
    //实名状态
    async orgTempuserBind() {
      try {
        let res = await apis.orgTempuserBind();
        if (res.code == 200) {
          this.authStaus = res.data.authStaus;
          this.orgName = res.data.orgName;
        }
      } catch (e) {
        console.log(e);
      }
    },
    //全屏设置
    toggleFullScreen() {
      if (this.canFullScreen) {
        if (this.isFullScreen) {
          // 关闭全屏
          this.exitFullScreen();
          this.isFullScreen = false;
        } else {
          // 打开全屏
          this.requestFullScreen(document.body);
          this.isFullScreen = true;
        }
      } else {
        this.$message.warning({
          content: "当前浏览器暂不支持全屏模式，请切换浏览器后重新尝试！",
          duration: 3,
        });
      }
    },
    requestFullScreen(element) {
      // 判断各种浏览器，找到正确的方法
      const requestMethod =
        element.requestFullScreen || // W3C
        element.webkitRequestFullScreen || // Chrome, safari
        element.mozRequestFullScreen || // FireFox
        element.msRequestFullscreen; // IE11
      if (requestMethod) {
        requestMethod.call(element);
      }
    },
    exitFullScreen() {
      var exitMethod =
        document.exitFullscreen || // W3C
        document.mozCancelFullScreen || // FireFox
        document.webkitExitFullscreen || // Chrome等
        document.msExitFullscreen; // IE11
      if (exitMethod) {
        exitMethod.call(document);
      }
    },
    addFullScreenListener() {
      const self = this;
      document.onkeydown = function (e) {
        if (e && e.keyCode === 122) {
          // 捕捉F11键盘动作
          e.preventDefault(); // 阻止F11默认动作
          self.toggleFullScreen();
        }
      };
      // 监听不同浏览器的全屏事件，并件执行相应的代码
      switch (self.browserKernel) {
        case "webkit":
          document.onwebkitfullscreenchange = function () {
            if (document.webkitIsFullScreen) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        case "gecko":
          document.onmozfullscreenchange = function () {
            if (document.mozFullScreen) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        case "trident":
          document.onmsfullscreenchange = function () {
            if (document.msFullscreenElement) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        case "others":
          document.onfullscreenchange = function () {
            if (document.fullscreen) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        default:
          break;
      }
    },
    tagClick(res) {
      console.log(res);
      this.loading = Loading.service({
        text: "更换主题中...",
        spinner: "el-icon-loading",
      });
      // // return false

      this.themecolor = res.color.split("#")[1];
      localStorage.setItem("ztColor", this.themecolor);
      toggleClass(document.body, "custom-" + this.themecolor);
      setTimeout(() => {
        this.loading.close();
      }, 1000);
      // for(let i in this.zColor){
      //     if(this.zColor[i].color == res.color){
      //         this.zColor[i].show = true
      //     }else{
      //          this.zColor[i].show = false
      //     }
      // }
    },
    handleCloseOne() {
      this.dialogFull = false;
      this.dialogPasswordVisible = false;
    },
    handleCloseTwo() {
      this.dialogFullTwo = false;
      this.dialogDutyVisible = false;
    },
    toChart() {
      this.$router.push("/maintain/statistics");
    },
    toChart2() {
      this.$router.push("/maintain/statement");
    },
    async getReadNews() {
      try {
        let res = await news.navNewsRead({});
        if (res.code == 200) {
          if (res.data) {
            this.Read = res.data;
          } else {
            this.Read = [];
          }
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getUnreadNews() {
      try {
        let res = await news.navNewsUnread({});
        if (res.code == 200) {
          if (res.data) {
            this.unRead = res.data;
            this.newsNumber = res.count; //标记未读消息数
          } else {
            this.newsNumber = 0;
            this.unRead = [];
          }
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        console.log(e);
      }
    },
    flushCom(path) {
      this.$router.push({
        path,
        query: {
          t: +new Date(), //保证每次点击路由的query项都是不一样的，确保会重新刷新view
        },
      });
      console.log(123);
      // this.$router.go(0);
    },
    // flushCom(url){
    //     // let route = this.$route.path;
    //     // if(route == url){
    //     //     // this.$router.go(0);
    //     //     location.reload();
    //     // }else{
    //     //     this.$router.push(url);
    //     // }
    // },
    async changeDuty() {
      try {
        let res = await apis.switchUserDuty({});
        if (res.code == 200) {
          this.dutyLists = res.list;
          this.dialogDutyVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleDutyChange(value, index) {
      this.choosedDuty = this.dutyLists[index];
    },
    changeUserDuty(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let res = await apis.updateUserDuty(this.choosedDuty);
            if (res.code == 200) {
              localStorage.setItem("roleType", res.user.leyeRole.roleType);
              localStorage.setItem("userNick", res.user.userNick);
              localStorage.setItem("userPhone", res.user.userPhone);
              localStorage.setItem("userImage", res.user.userImage);
              localStorage.setItem("userId", res.user.userId);
              localStorage.setItem("id", res.user.id);
              localStorage.setItem("passInit", res.user.passInit);
              localStorage.setItem("makerId", res.user.makerId);
              localStorage.setItem(
                "dutyList",
                JSON.stringify(res.user.dutyList)
              );
              localStorage.setItem(
                "menuList",
                JSON.stringify(res.user.menuList)
              );
              let roleType = localStorage.getItem("roleType");
              let menuList = localStorage.getItem("menuList");
              let dutyList = localStorage.getItem("dutyList");
              if (roleType == 0) {
                if (dutyList.indexOf("企业招聘") > -1) {
                  this.$router.push({
                    path: this.redirect || "/recruitSys/recruitIndex",
                    query: this.otherQuery,
                  });
                } else {
                  //企业
                  if (this.menuList.indexOf("企业概况") > -1) {
                    //判断有无概况权限
                    this.$router.push({
                      path: this.redirect || "/maintain/statement",
                      query: this.otherQuery,
                    });
                  } else {
                    this.$router.push({
                      path: this.redirect || "/",
                      query: this.otherQuery,
                    });
                  }
                }
              }
              // 处理按钮并存入 localStorage
              getAuthority();
              this.$message.success("切换成功！");
              this.dialogDutyVisible = false;
              this.dialogFullTwo = false;
              location.reload();
            } else {
              this.$message.error(res.msg);
            }
          } catch (e) {
            console.log(e);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changePWD() {
      this.dialogPasswordVisible = true;
    },
    changeThePassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let data;
            localStorage.getItem("passInit");
            if (passInit == null) {
              data = {
                newPass1: this.pwdData.newPwd,
                newPass2: this.pwdData.conPwd,
                userId: localStorage.getItem("userId"),
              };
            } else {
              data = {
                oldPass: this.pwdData.oldPwd,
                newPass1: this.pwdData.newPwd,
                newPass2: this.pwdData.conPwd,
                userId: localStorage.getItem("userId"),
              };
            }

            let res = await apis.updateUserPassword(data);
            if (res.code == 200) {
              this.dialogPasswordVisible = false;
              this.dialogFull = false;
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.logout();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          } catch (e) {
            console.log(e);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    logout() {
       let _this = this;
       let lastTime = new Date().getTime();
       this.pointAmount(this.currentTime,lastTime,function(){
         let res = apis.userlogout();
          console.log(res);
          RongIMLibM.disconnect().then(() => {
            console.log("成功断开");
          });
          // localStorage.setItem("token", "");
          localStorage.setItem("roleType", "");
          localStorage.setItem("userNick", "");
          localStorage.setItem("passInit", "");
          localStorage.setItem("userPhone", "");
          localStorage.setItem("userImage", "");
          localStorage.setItem("userId", "");
          localStorage.setItem("id", "");
          // localStorage.setItem('makerId','');
          localStorage.setItem("menuList", "");
          localStorage.setItem("dutyList", "");
          localStorage.setItem("buttonList", "");
          localStorage.setItem("msgdialog", "");
          _this.$store.dispatch("delAllViews");
          if(_this.$xlpSource){
            _this.$router.push("/xlpLogin");
          }else{
            _this.$router.push("/leyeLogin");
          }
       })
  
      
    },
    async getwechatcode() {
      try {
        let data = {
          invitionId: localStorage.getItem("id"),
          invitionType: 2,
        };
        let res = await apis.wechatcode(data);
        if (res.code == 200) {
          this.getwechaturl();
          if(this.$xlpSource){
            this.wechatimg = 'https://leylh.oss-cn-beijing.aliyuncs.com/xlpcode.png';
          }else{
            this.wechatimg = res.data;
          }
          
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getwechaturl() {
      try {
        let data = {
          invitionId: localStorage.getItem("id"),
          invitionType: 3,
        };
        let res = await apis.wechaturl(data);
        if (res.code == 200) {
          if(this.$xlpSource){
             this.wechaturl = 'https://xlp.leylh.com';
             this.wechaturlText = 'https://xlp.leylh.com'
          }else{
             this.wechaturl = res.data;
             this.wechaturlText = res.data
          }
         
        } else {
          this.$message.error(res.msg);
        }
      } catch (e) {
        console.log(e);
      }
    },
    sharebtn() {
      this.getwechatcode();
      this.sharedialog = true;
    },
    sharehandleClose() {
      this.sharedialog = false;
    },
    // handleOpen(key, keyPath) {
    // // console.log(key, keyPath);
    // },
    // handleClose(key, keyPath) {
    // // console.log(key, keyPath);
    // },
    collapseMenu() {
      let flag = this.isCollapse;
      this.isCollapse = !flag;
    },
    async getMenu() {
      try {
        let res = await apis.getMenu({});
        if (res.code == 200) {
        } else {
          this.$router.push("/leyeLogin");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async pointAmount(time,istime,fn){
      
      if((istime - time)  < 1000){
         if(fn){
            fn()
          }
        return false
      }
      let data = {
        comeTime:time,
        outTime: istime,
        pageCode:'PG0000034',
        type:6,
        visitType:4
      }
      try {
        let res = await apis.pointAmount(data);
        if (res.code == 200) {
          
          if(fn){
            fn()
          }
        } else {
          // this.$router.push("/leyeLogin");s
        }
      } catch (e) {
        console.log(e);
      }
    },
    OperatingWebsite() {
      let currentTime = this.currentTime;
      //console.log(currentTime, "currentTime");
      let lastTime = new Date().getTime();
      //console.log(lastTime, "lastTime");
      let timeOut1 = 30 * 60 * 1000; //设置时间 10分钟
      let timeOut = 30 *24 * 60 * 60 * 1000
      if(lastTime - currentTime > timeOut1){
        // 超过10分钟 判断其离线
        this.pointAmount(this.currentTime,lastTime)

      }
      if (lastTime - currentTime > timeOut) {
        // 未操作页面，跳转登录页面
        this.currentTime = new Date().getTime();
        alert("登录已超时，请重新登录！");
        this.logout();
        // const fullPath = this.$route.fullPath;
        // const query = this.$Base64.encode(fullPath);
        // this.$router.push({
        //     path: "/leyeLogin",
        //     query: {
        //         type: query
        //     }
        // });
      } else {
        this.currentTime = new Date().getTime();
      }

      // //页面弹框 默认10分钟不点击操作 则跳转到登录
      // var currentUrl = window.location.href;//获取当前页面地址
      // var timefly = 1000000; //超时时间
      // var beginDt = new Date();//把得到的当前时间放入变量作为初始时间
      // var gourl = "/LeyeProject/manage/view/lelogin.jsp";//需要跳转的地址
      // //document.onmousemove = retime;//当鼠标移动时的时间
      // document.onmousedown = retime;//当鼠标点击重新获取当前时间放入变量作为初始时间

      // function retime() {
      //     beginDt = new Date();
      // }
      // var xxflat = 0;
      // function checkTime() {
      //     nowDt = new Date();//得到当前时间放入变量
      //     if(xxflat == 0){
      //         if ((nowDt - beginDt) > timefly) {
      //             xxflat = 1;
      //             alert('登录账号到期，请重新登录!');
      //             window.top.location.href = gourl; //如果当前时间减去初始时间大于超时时间，就执行自动跳转
      //         }
      //     }
      // }

      // //判断当前页面是否为跳转页面
      // if (currentUrl == gourl) {
      // clearInterval("checkTime()");
      // } else {
      // setInterval("checkTime()", 1000);//每间隔1000毫秒执行checkTime函数检查是否超时
      // }
    },

    // 前往文档中心
    gotoFileCenter() {
      this.$router.push("/system/fileCenter");
    },
    // 切换主题
    changeCss() {
      this.dialogDutyVisibleCss = true;
    },
    isFullscreen() {
      return (
        document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        false
      );
    },
    changeAll() {
      var docElm = document.documentElement;
      if (
        document.fullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        }
        //FireFox
        else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        }
        //Chrome等
        else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        }
        //IE11
        else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      }
    },
  },
};
</script>
<style>
.person /deep/ el-dropdown-menu {
  width: 197px;
}
.box-card /deep/ .el-card__body {
  padding: 20px;
  overflow: scroll;
  max-height: 500px;
  padding-bottom: 60px;
}
.box-card /deep/ .el-card__body {
  overflow: auto;
}
.box-card /deep/ .el-card__body::-webkit-scrollbar {
  width: 0 !important;
}
</style>
<style lang="scss" scoped>
.vitem-down-color {
  width: 100%;
  height: 35px;
  line-height: 35px !important;
}
.hfshezhi {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 3px;
  float: left;
  margin-top: 7px;
  margin-right: 5px;
}
.hfColor0 {
  background: #f5222d;
}
.hfColor1 {
  background: #fa541c;
}
.hfColor2 {
  background: #faad14;
}
.hfColor3 {
  background: #00ceb9;
}
.hfColor4 {
  background: #52c41a;
}
.hfColor5 {
  background: #1890ff;
}
.hfColor6 {
  background: #2f54eb;
}
.hfColor7 {
  background: #722ed1;
}
.hfColor8 {
  background: #000;
}
.margin_icon {
  margin-left: 24px;
}
.el-dropdown {
  vertical-align: middle;
  // margin: 0 10px;
}
.el-dropdown-menu {
  padding: 0;
}

.item {
    margin-top: 10px;
    margin-left: -10px;

}
.app-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.sidebar-logo {
  height: 60px;
  background: #fff;
  // background-color: #00ceb9;
  // border-bottom: 1px solid #fff;
  // margin-bottom: 24px;
  img {
    width: 162px;
    height: 52px;
    // margin-left: 6px;
    margin-top: 6px;
  }
}
.sidebar-logoFuSHENG {
  height: 60px;
  background-color: #00ceb9;
  border-bottom: 1px solid #fff;
  // margin-bottom: 24px;
  img {
    width: 82px;
    height: 41px;
    margin-left: 54px;
    margin-top: 7px;
  }
}
.main-box1 {
  box-shadow: none !important;
  background: none !important;
}
.main-box {
  // padding: 25px;
  // box-shadow: 0 10px 19px 0 rgba(0,0,0,.05);
  border-radius: 4px;
  width: 98%;
  margin: 0 auto;
  margin-top: -13px;
  margin-bottom: 23px;
  background: #fff;
  box-shadow: 0 10px 19px 0 rgba(0, 0, 0, 0.05);
  // padding-top: 15px
}
.small-box {
  width: 98%;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 2px;
}
.sidebar-box {
  width: 209px;
  height: calc(100% - 60px);
  // border: 1px solid #fafafa;
  box-shadow: 0 0 6px rgba(174, 174, 174, 0.14);
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 auto;
}
.slide {
  width: 54px !important;
  transition: width ease-in 0.28s;
}
.el-menu-item {
  border-left: 2px solid #fff;
}
#app .sidebar-container .el-submenu .el-menu-item.is-active {
  background-color: #ebfbfa !important;
  color: #00ceb9;
  border-left: 2px solid #00ceb9;
}
.sidebar-container {
  transition: width 0.28s;
  width: 190px !important;
  background-color: #fff;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
}
.main-container {
  min-height: 100%;
  -webkit-transition: margin-left 0.28s;
  transition: margin-left 0.28s;
  margin-left: 190px;
  position: relative;
}
.fixed-header {
  position: fixed;
  left: 190px;
  top: 0;
  z-index: 1000;
  width: calc(100% - 190px);
}
.el-submenu__title i {
  color: #fff !important;
}
.hideSidebar {
  .fixed-header {
    width: calc(100% - 54px);
    left: 54px;
  }
}
.tagsClass {
  width: 25px;
  height: 25px;
  border: none !important;
  margin-right: 6px;
  cursor: pointer;
  // float: left;
}
.nav {
  position: relative;
  width: 100%;
  height: 60px;
  box-shadow: 0 1px 6px #e7e6e6;
  // background-color: #00ceb9;
  border-bottom: 1px solid #fff;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .nav-slide {
    display: inline-block;
    margin-left: 15px;
    .collapse-menu {
      font-size: 32px;
      color: #fff;
      line-height: 88px;
    }
  }
  .nav-menu {
    float: right;
    margin-right: 40px;
  }
}
.user-avatar {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  vertical-align: middle;
  margin-right: 10px;
  margin-left: 10px;
}
.avatar-wrapper {
  // margin-right: 12px;
  span {
    display: inline-block;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    vertical-align: middle;
    margin-right: 4px;
  }
}
.panel {
  min-height: 100px;
  padding: 0 10px 10px;
  a {
    font-size: 14px;
    line-height: 26px;
  }
}
.head-news {
  color: #ccc;
  border-bottom: 1px dashed #ccc;
  span {
    display: inline-block;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}
.head-news-more {
  display: block;
  text-align: right;
  color: #00ceb9;
  line-height: 26px;
}
.duty-item {
  height: 30px;
}
.colorTitle {
  font-size: 15px;
  line-height: 35px;
}
.user-fullscreen {
  cursor: pointer;
  width: 21px;
  height: 21px;
  border-radius: 10px;
  vertical-align: middle;
}
.imgBox {
  width: 21px;
  font-size: 21px;
}
.icon_se {
  width: 25px;
  height: 25px;
  margin-left: -3px;
  position: relative;
  top: -1px;
  display: inline-block;
}
.person-img img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-top: 5px;
  margin-left: 10px;
}
.person-img0 img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 10px;
}
.person-img1 img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 10px;
  margin-top: 14px;
}
.person-img2 img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 10px;
}
.person-name {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  margin-top: 5px;
}
.person-img{
  margin-top: 5px;

}
.person-phone {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
.person-right {
  display: flex;
  height: 65px;
  position: relative;
}
.person-r1 {
}
.pr {
  position: absolute;
  font-size: 12px;
  color: #333;
  top: 5px;
}
.pr1 {
  position: absolute;
  color: #999;
  font-size: 12px;
  top: 25px;
  display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
  -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
  overflow: hidden; /*超出的文本隐藏*/
  text-overflow: ellipsis; /* 溢出用省略号*/
  -webkit-box-orient: vertical;
}
.erweimapic {
  width: 180px;
  height: 180px;
  margin: auto;
  margin-bottom: 8px;
}
.erweimapic img {
  width: 180px;
  height: 180px;
}
.savepic {
  font-size: 14px;
  font-weight: 500;
  color: #1a67f6;
  text-decoration: underline;
  text-align: center;
  margin-bottom: 12px;
  cursor: pointer;
}
.yaoqinglj {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  margin-bottom: 8px;
  margin-top: 10px;
}
.yaoqing {
  width: 183px;
  height: 36px;
  line-height: 36px;
  background: #f5f5f5;
  border-radius: 4px 0px 0px 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 9px;
}
.copylj {
  width: 88px;
  height: 36px;
  background: #1a67f6;
  border-radius: 0px 4px 4px 0px;
  font-weight: 500;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
// .card_box{
//   position: relative;
// }
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 380px;
  max-height: 500px;
  background: #f2f2f2;
  position: fixed;
  bottom: 20px;
  right: 0;
  z-index: 99999999999;
}

.msglist {
  width: 100%;
  background: #fff;
  margin-bottom: 10px;
  position: relative;
  box-shadow: 0px 6px 12px 0px rgba(101, 114, 154, 0.13);
}
.msgimg {
  height: 50px;
  margin-top: 12px;
  margin-left: 20px;
}

.msgtitle {
  font-size: 16px;
  font-weight: 700;
  padding: 10px 10px;
}
.msgcontent {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  padding: 0px 10px 10px 10px;
}
.msgdelete {
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.msgsee {
  text-align: right;
  margin-right: 10px;
  color: #1890ff;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  float: right;
}
.msgRefresh {
  width: 70px;
  line-height: 25px;
  height: 25px;
  text-align: center;
  border-radius: 6px;
  background: #f2f2f2;
  color: #d6d6d6;
}
.msgRefresh1 {
  width: 70px;
  line-height: 25px;
  height: 25px;
  text-align: center;
  border-radius: 6px;
  background: #1890ff;
  color: #fff;
  margin-left: 5px;
}
</style>
